import React, { useContext, useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { IUserFields } from "../types";
import APIService from "src/services/Api";
const cookies = new Cookies();

export interface AuthContextInterface {
  token: string | null;
  expiresAt: number | null;
  isAuthenticated: boolean;
  user: IUserFields | null;
  activateAccount: () => void;
  updateUserData: () => void;
  setUserData: (
    id: string,
    email: string,
    fullname: string,
    phone: string,
    country: string,
    birthday: string,
    verifyAccount: boolean,
    role: string,
    verifiedIdentity: boolean,
    createdAt: string,
    photoUrl: string,
    nickname: string,
    lastConnection: string
  ) => void;
  logout: () => void;
}

export const authContextDefaults: AuthContextInterface = {
  expiresAt: null,
  token: null,
  isAuthenticated: cookies.get("isAuthenticated") || false,
  user: cookies.get("userdata") || null,
  setUserData: () => null,
  logout: () => null,
  activateAccount: () => null,
  updateUserData:  () => null
};
interface AuthProviderOptions {
  children: React.ReactElement;
}

export const AuthProvider = ({ children }: AuthProviderOptions) => {
  const [isAuthenticated, setisAuthenticated] = useState(false);
  const [expiresAt, setExpiresAt] = useState(null);
  const [token, setToken] = useState<string | null>(null);
  const [user, setUser] = useState<IUserFields | null>(
    cookies.get("userdata") || null
  );
  
  const logout = () => {
    setisAuthenticated(false)
  };

  useEffect(() => {
    if(localStorage.getItem("authToken") && cookies.get("isAuthenticated") ){
      const token = localStorage.getItem("authToken");
      const isAuth = cookies.get("isAuthenticated")
      setisAuthenticated(token && isAuth)
    }
  }, [])


  const updateUserData = async() => {
    const query = await APIService.getUserInfo({ userId: user?.id || '' });
    let userData = query.data.data.user;
    if(userData?.id){
      setUserData(userData.id,
        userData.email,
        userData.fullname,
        userData.phone,
        userData.country,
        userData.birthday,
        userData.verifyAccount,
         userData.role,
         userData.verifiedIdentity,
         userData?.createdAt || '',
         userData?.photoUrl || '',
         userData?.nickname || '',
         userData?.lastConnection || ''
         )
    }
  }
  const setUserData = (
    id: string,
    email: string,
    fullname: string,
    phone: string,
    country: string,
    birthday: string,
    verifyAccount: boolean,
    role: string,
    verifiedIdentity: boolean,
    createdAt: string,
    photoUrl: string,
    nickname: string,
    lastConnection: string
  ) => {
    cookies.set("userdata", {
      id,
      email,
      fullname,
      phone,
      country,
      birthday,
      verifyAccount,
      role,
      verifiedIdentity,
      createdAt,
      photoUrl,
      nickname,
      lastConnection
    },{path: '/'});

    cookies.set("isAuthenticated", true, {path: '/'} );
  
    setisAuthenticated(true);
    setToken('');
    setUser({
      id,
      email,
      fullname,
      phone,
      country,
      birthday,
      verifyAccount,
      role,
      verifiedIdentity,
      createdAt,
      photoUrl,
      nickname,
      lastConnection
    });
  };
  const activateAccount = () => {
    if(isAuthenticated){
      setUserData(
        user?.id || '',
        user?.email || '',
        user?.fullname || '',
        user?.phone || '',
        user?.country || '',
        user?.birthday || '',
        user?.verifyAccount || false,
        user?.role || 'user',
        user?.verifiedIdentity || false,
        user?.createdAt || '',
        user?.photoUrl || '',  
        user?.nickname || '',
        user?.lastConnection || ''
      )
    }
  };
  return (
    <AuthContext.Provider
      value={{
        isAuthenticated:cookies.get('isAuthenticated') || false,
        user,
        expiresAt,
        token,
        setUserData,
        updateUserData,
        logout,
        activateAccount,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export const AuthContext =
  React.createContext<AuthContextInterface>(authContextDefaults);

export const UseAuth = () => useContext(AuthContext);
